module.exports = __webpack_public_path__ + "media/MRI4A.ecaecc5e.mp3";